import siteConfig from './siteConfig.js'
import okaTool from './okaTool.js'
import store from './store.js'
import axios from 'axios'
import { Decimal } from 'decimal.js';

export default {
    install: function(Vue, options) {
        Vue.prototype.$siteTool = this;
    },
    dayRestriction: function(opt){
       //20221004 修改內銷選擇器 https://www.notion.so/01ae5f3042094aedbf153f1d99ca6a3f

        let $list = store.state.selectedDateList
        let $now = new Date(),
            _year = $now.getFullYear(),
            _month = $now.getMonth();

        if( opt.date ) { //日
            let $optDate = okaTool.timeInterval({
                time: new Date(opt.year, opt.month - 1, opt.date),
                unit: 'date'
            })

            return $list.indexOf($optDate.ymd) !== -1
        }else { //月
            let _optYear = opt.year,
            _optMonth = opt.month - 1;
            return _optYear === _year && _optMonth >= _month && _optMonth - _month < 2 //Math.abs(_optMonth - _month) < 2
        }
    },
    getProductInfo: function(opt){
        let $state = store.state,
            $selectedDateList = $state.selectedDateList;

        let _nextDate = $selectedDateList[0],
            $nextDate = null;
            
        if( _nextDate ) {
            $nextDate = new Date(_nextDate);
        }else {
            $nextDate = new Date();
        }

        let _date = opt.date,
            $date = null;

        if( _date ) {
            $date = new Date(_date);
        }else {
            $date = new Date();
        }

        let _dDate = ''

        if( $nextDate > $date ) {
            _dDate = $nextDate.toLocaleDateString();
        }else {
            _dDate = $date.toLocaleDateString();
        }

        let _url = this.apiUrl({
                class: 'Product',
                func: 'Info',
            }),
            $condition = {
                product_sn: opt.sn,
                dDate: _dDate, //沒選客需日就帶最近的那一天
            }

        store.commit('initPackageAndQuality', _dDate);

        return axios.post(_url, $condition);
    },
    addCUNO: function(name, callback){

        let _url = this.apiUrl({
                class: 'AdcunoAddress',
                func: 'CheckInERP',
            }),
            $condition = {
                cuno: name,
            }

        axios.post(_url, $condition).then(res => { //弄完所有設定後開始取資料
            let $data = res || {}

            if( $data.adcuno && $data.cufn && $data.dlsite ) {

                if( callback && typeof callback === 'function' ) {
                    callback($data);
                }
            }else {

                store.commit('pushPopUp', {
                    type: 'alert',
                    content: {
                        html: 'No User Data.',
                    }
                });
            }
        }).catch(error => {

            store.commit('catchError', {
                error: error,
                callback: () => {
                    this.addCUNO(name, callback);
                }
            });
        });
    },
    initShoppingCart: function(cart){
        let _customer_need_date = cart.customer_need_date || 0,
            $customer_need_date = null;

        if( !_customer_need_date ) {
            $customer_need_date = new Date();
        }else {
            $customer_need_date = new Date(_customer_need_date * 1000);
        }

        let _result = '';

        let _year = $customer_need_date.getFullYear(),
            _month = $customer_need_date.getMonth() + 1,
            _date = $customer_need_date.getDate();

        _result = _year +'-'+ okaTool.doubleCount(_month) +'-'+ okaTool.doubleCount(_date);

        if( !cart.imageurl ) {
            cart.imageurl = siteConfig.emptyProductPhoto;
        }
        
        cart.customer_need_date = _result;

        if( !cart.outmfct  ) {
            cart.outmfct = '';
        }

        return cart;
    },
    reInitShoppingCart: function(cart){
        let _customer_need_date = cart.customer_need_date,
            $customer_need_date = new Date();

        if( _customer_need_date ) {
            $customer_need_date = new Date(_customer_need_date);
        }

        let _result = parseInt($customer_need_date / 1000, 10);
        
        cart.customer_need_date = _result;

        return cart;
    },
    receiveEvent: function(env, arg){ //將收到的方法，推送給其他方法執行
        let _func = arg[0]; //方法

        if( env[_func] || (env.content && env.content[_func]) ) { //如果自己有這個方法
            Array.prototype.shift.call(arg, 1); //原本要送的參數

            let $_func = env[_func] || (env.content && env.content[_func]);

            $_func.apply(env, arg); //送進去執行
        }else {
            Array.prototype.unshift.call(arg, 'sendEvent'); //把 'sendEvent' 送去第 0 個參數

            if( env.$emit ) {
                env.$emit.apply(env, arg); //送到上面的 'sendEvent'
            }
        }

        return true;
    },
    apiUrl: function(opt){ //傳 api 的公用方法
        let _url = opt.url || siteConfig.ApiUrl,
            _class = opt.class || '',
            _func = opt.func || '';

        _url = _url;

        if( _class ) {
            _url = _url +'/'+ _class;
        }

        if( _func ) {
            _url = _url +'/'+ _func;
        }

        return _url;
    },
    getDefaultUser: function(){

        return {
            sn: null,
            parentsn: null,
            co: '',
            div: '',
            salid: '',
            cuno: '',
            accountid: '',
            email: '',
            virtual_account: null,
            first_login: false,
            ismain: false,
            isfactory: false,
            adscuno: '',
            cuabr: '',
            cufn: '',
            subs: [],
            bos: '',
            cellphone: '',
            certificate: null,
            cucy: '',
            magtit: '',
            phone: '',
            rfno: '',
            dlsite: '', //交貨地址
            totalcredit: 0,
            cukd: '', //客戶類別
        }
    },
    objToCon: function(obj){ //object to condition
        let $array = [];

        if( typeof obj === 'object' ) {

            for( let _key in obj ) {

                $array.push({
                    key: _key,
                    value: obj[_key]
                });
            }
        }

        return $array;
    },
    conToObj: function(arr){ //object to condition
        let $object = {}

        if( Array.isArray(arr) && arr.length > 0 ) {

            arr.forEach(item => {
                $object[item.key] = item.value;
            })
        }

        return $object;
    },
    download: function(res){
        let $file = window.URL.createObjectURL(new Blob([res.data])),
            _name = decodeURI(res.headers['content-disposition'].replace(/\"|\'/g, '').replace('attachment; filename=', ''));

        this.downloadCore($file, _name);
    },
    downloadCore: function(file, name){
        let $link = document.createElement('a');

        $link.href = file;
        $link.setAttribute('download', name); //or any other extension

        document.body.appendChild($link);
        $link.click();
        window.URL.revokeObjectURL(file);

        return true;
    },
    makeNavTree: function(navList){
        let $navList = navList || [];
        
        let $result = [];

        $navList.forEach(nav => {
            let _parentSN = nav.parentsn;

            if( _parentSN === 0 ) {
                $result.push(nav);
            }
        });

        $navList.forEach(nav => {
            let _parentSN = nav.parentsn;

            if( _parentSN !== 0 ) {
                let $parent = $navList.find(parent => {
                        return parent.sn === _parentSN;
                    });

                if( $parent ) {
                    $parent.subs.push(nav);
                }
            }
        });

        let $_sort = (a, b) => {
                if( a.sort > b.sort ) {
                    return 1;
                }else if( a.sort < b.sort ) {
                    return -1;
                }else {
                    return 0;
                }
            }

        let $_sortLoop = (item) => {

                if( item.subs && item.subs.length > 1 ) {
                    item.subs.sort($_sort);

                    $_sortLoop(item.subs);
                }
            }

        $result.sort($_sort);

        $result.forEach(item => {
            $_sortLoop(item);
        });

        return $result;
    },
    cloneTitle: function(title, prop, cloneSet, oriSet){
        let $target = title.find(item => {
                return item.prop === prop;
            });

        if( $target ) {
            let _index = title.indexOf($target),
                $clone = okaTool.copy($target);
            
            if( cloneSet ) {

                okaTool.extend({
                    target: $clone,
                    ref: cloneSet,
                    copy: false,
                    hard: true
                });
            }

            if( oriSet ) {

                okaTool.extend({
                    target: $target,
                    ref: oriSet,
                    copy: false,
                    hard: true
                });
            }
            
            title.splice(_index, 0, $clone);
        }
    },
    getPrice: function(node, date){
        let $state = store.state;

        let _langID = $state.langID,
            $langLibrary = $state.langLibrary || {},
            $library = $langLibrary[_langID] || {}

        let $priceObject = $state.priceObject,
            _date = new Date().toLocaleDateString();

        if( date ) {
            _date = new Date(date).toLocaleDateString();
        }

        let $user = $state.user,
            _userSn = $user.sn;

        let _available = node.available || false;

        if( !_userSn ) {
            return $library['site.func.signinalert']
        }else if( !_available ) {
            return $library['site.func.purchasealert']
        }else {
            let $node = $priceObject[node.product_sn] || {},
                _price = $node[_date] || null;

            return _price || $library['site.func.pricealert']
        }
    },
    computedPrice: function(opt, date){
        let $packageData = this.getPackage(opt),
            $qualityList = this.getQuality(opt),
            $product = this.getProduct(opt) || {},
            _result = this.getPrice($product, date);

        let _product_s = opt.product_s,
            _package = opt.package_s,
            _quality = opt.quality;

        if( typeof _result === 'number') {
            _result = new Decimal(_result);

            if( _package !== null || _package !== undefined ) {
                let $targetPackage = $packageData.find(item => item.product_s === _product_s && item.package_s === _package);

                if( $targetPackage && $targetPackage.inprice !== undefined ) {
                    _result = _result.add(new Decimal($targetPackage.inprice));
                }
            }

            if( _quality !== null || _quality !== undefined ) {
                let $targetQuality = $qualityList.find(item => item.product_s === _product_s && item.quality === _quality);

                if( $targetQuality && $targetQuality.inprice !== undefined ) {
                    _result = _result.add(new Decimal($targetQuality.inprice));
                }
            }

            _result = _result.toFixed(3);
    
            return parseFloat(_result, 10);
        }else {
            return _result;
        }
    },
    getProduct: function(opt){
        /* 20221007_因應中類名稱與中類代碼混亂，加上跨事業部取消，
            所以修改產品對應條件為「事業部 + 產品品別」 */
       
        let $state = store.state,
            $productList = $state.productList || [];

        let _codiv = opt.dsr_codiv,
            _product_s = opt.product_s;

        let $result = $productList.find(item => item.product_codiv === _codiv && item.product_s === _product_s );
        if( $result ) {
            return $result;
        }else {
            console.log('找不到該商品');

            return null;
        }
    },
    getPackage: function(opt){
        let $state = store.state,
            $packageData = $state.packageData || [],
            _product_s = opt.product_s,
            _codiv = opt.dsr_codiv || opt.product_codiv;

        if( _product_s !== null ) {
            //因為有些事業部的包裝別為空值，所以只能排除NULL
            return $packageData.filter(item => item.package_s !== null && item.product_s === _product_s && item.codiv === _codiv);
        }else {
            return []
        }
    },
    getOutmfct: function(opt){
        let $state = store.state,
            $dispatchList = $state.dispatchList || [],
            _product_s = opt.product_s;

        return $dispatchList.filter(item => item.dsr === _product_s);
    },
    getQuality: function(opt) {
        let $state = store.state,
            $qualityList = $state.qualityList || [],
            _product_s = opt.product_s,
            _codiv = opt.dsr_codiv || opt.product_codiv;

        if( _product_s !== null ) {
            //因為有些事業部的品級為空值，所以只能排除NULL
            return $qualityList.filter(item => item.quality !== null && item.product_s === _product_s && item.codiv === _codiv);
        }else {
            return []
        }
    },
    getLabelClassName: function(str){

        if( str === '推薦' ) {
            return 'SPEC';
        }else if( str === '熱賣' ) {
            return 'HOT';
        }else if( str === '特價' ) {
            return 'SALE';
        }else if( str === '獨家' ) {
            return 'SPEC';
        }else if( str === '新品' ) {
            return 'NEW';
        }else if( str === '售完' ) {
            return 'SOLD OUT';
        }else if( str === '副牌料' ) {
            return '副牌料';
        }else {
            return str
        }
    },
    versionComparer: function(clientVersion, serverVersion) {
        let $clientVersion = clientVersion.split('.'),
            $serverVersion = serverVersion.split('.');

        let _serverIsNew = false;

        for( let _i = 0; _i < 3; _i++ ) {
            let _serverVersion = parseInt($serverVersion[_i], 10),
                _clientVersion = parseInt($clientVersion[_i], 10)

            if( _serverVersion !== _clientVersion ) {

                if( _serverVersion > _clientVersion ) {
                    _serverIsNew = true;
                }
    
                break;
            }
        }

        return _serverIsNew;
    },
}
